import { render, staticRenderFns } from "./TireInfo.vue?vue&type=template&id=2e60ff51&scoped=true&"
import script from "./TireInfo.vue?vue&type=script&lang=js&"
export * from "./TireInfo.vue?vue&type=script&lang=js&"
import style0 from "./TireInfo.vue?vue&type=style&index=0&id=2e60ff51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60ff51",
  null
  
)

export default component.exports